import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfig } from '../../../core/api.service';
import { Observable } from 'rxjs';
import { BasicAccountInfo } from '../../../core/models/account-management/basic-account-info';

@Injectable()
export class AuthenticationService {

    constructor(private http: HttpClient) { }
    private apiConfigInstance = ApiConfig.getInstance();  

    private cookieKey: string = 'authKey';
    private cookieTokenKey: string = 'authKeyToken'; 
    private sessionCheckKey: string = 'sessionDuration';
    private defaultCookieTimeout: number = 5;

    authenticateUser(username: string, password: string): Observable<any> {
        var apiUrl = '/webapi/api/authentication/login';
        return this.apiConfigInstance.postData(this.http, apiUrl, JSON.stringify({ username: username, password: password }));
    }

    refreshAuthorizationToken(timeout: number): Observable<any> {
        var apiUrl = '/webapi/api/authentication/RefreshToken?duration=' + timeout;
        return this.apiConfigInstance.getData(this.http, apiUrl);
    }

    processUserLogin(account: BasicAccountInfo, timeout: number, notifyDuration: number, authToken: string) {
        if (account.IsGuestLogin) {
            this.apiConfigInstance.setCookie(this.cookieTokenKey, authToken); // session cookie for guest
        } else {
            this.apiConfigInstance.setCookie(this.cookieTokenKey, authToken, timeout);
        }
        this.initializeUserCookieAndSessionTimeout(account, timeout, notifyDuration);
    }

    //notify duration is the how long before cookie expires that we should inform the user
    initializeUserCookieAndSessionTimeout(account: BasicAccountInfo, timeout: number, notifyDuration: number) {
        if (!this.apiConfigInstance.getCookieObject(this.sessionCheckKey)) {
            this.apiConfigInstance.removeCookie(this.sessionCheckKey);
        }

        if (timeout > notifyDuration) {
            this.apiConfigInstance.setCookieObject(this.sessionCheckKey, true, timeout - notifyDuration);
        }

        this.refreshAuthorizationToken(timeout).subscribe(output => {
            if (output && output.authenticationToken) {
                if (account.IsGuestLogin) {
                    this.apiConfigInstance.setCookie(this.cookieTokenKey, output.authenticationToken);
                } else {
                    this.apiConfigInstance.setCookie(this.cookieTokenKey, output.authenticationToken, timeout);
                }
            } else if (output && output.authenticationToken === "") {
                this.apiConfigInstance.removeCookie(this.cookieKey);
                this.apiConfigInstance.removeCookie(this.cookieTokenKey);
            }
        });

        this.initializeUserCookie(account, timeout);      
    }

    initializeUserCookie(account: BasicAccountInfo, cookieTimeout) {

        if (!this.apiConfigInstance.getCookieObject(this.cookieKey)) {
            this.apiConfigInstance.removeCookie(this.cookieKey);
        }
        if (account.IsGuestLogin) {
            this.apiConfigInstance.setCookieObject(this.cookieKey, account);
        } else {
            this.apiConfigInstance.setCookieObject(this.cookieKey, account, cookieTimeout);
        }
        return this.apiConfigInstance.getCookieObject(this.cookieKey);
    }


    getUserCookie() {
        return this.apiConfigInstance.getCookieObject(this.cookieKey);
    }

    removeUserCookie() {
        this.apiConfigInstance.removeCookie(this.cookieKey);
        this.apiConfigInstance.removeCookie(this.cookieTokenKey);
    }

    
    authenticateVirtualUser(userID: number ): Observable<any> {
        var apiUrl = '/webapi/api/authentication/virtualLogin';
        return this.apiConfigInstance.postData(this.http, apiUrl, JSON.stringify({ userID: userID }));
    }

    
}

